import css from '../../desktop.scss';
import { ensure } from '../../../../utils';
import { links } from '../../../common';

const Column = item => {
  const hasSubs = item.subs && item.subs.length;
  return `
<li class="${css.menuColumn}" data-hook="link_item">
  <p class="${css.menuHeading}" data-hook="${item.dataHook}" data-bi-name="${item.name}">${ensure(item.text) || ''}</p>
  ${
    hasSubs
      ? links(
          item.subs,
          {
            list: css.menuList,
            item: css.menuItem,
          },
          null,
          null,
          null,
          {
            'data-hook': 'link_item',
          },
          null,
        )
      : ''
  }
</li>`;
};

const Columns = columns =>
  `<ul class="${css.menu}" data-hook='links_group'>${columns.map(item => Column(item)).join('')}</ul>`;

export default Columns;
